<template>
	<div v-loading="loadings.main">
		<h2>
			{{ info.brand.name }} {{ info.name }}
			<small>{{ info.color_name }}</small>
		</h2>
		<div class="content-box" v-loading="loadings.price" v-if="userPrivilegeMapping[12]">
			<h3 class="mb-3">价格信息</h3>
			<div class="tips-box">
				填0的，将默认使用上一级价格。如果单颜色尺寸的价格有所不同，请在下面列表内编辑
			</div>
			<el-form
				ref="priceForm"
				:model="info"
				status-icon
				label-position="left"
				label-width="120px"
				size="mini"
				v-loading="loadings.main"
				v-if="hasGetTableDataModel"
				@submit.native.prevent
				:rules="rules"
			>
				<div class="row">
					<div
						:class="key.col ? 'col-md-' + key.col : 'col-md-12'"
						v-for="(key, index) in fields"
						:key="index"
					>
						<el-form-item
							:label="tableDataModel[key.name].show_name"
							:prop="key.name"
							v-if="key.name != 'null'"
						>
							<field-editor
								:width="key.width"
								v-model="info[key.name]"
								@change.native="handleFormEdited(key.name)"
								@change="handleFormEdited(key.name)"
								:field-info="tableDataModel[key.name]"
							></field-editor>
						</el-form-item>
					</div>
					<!-- 配送相关手写 -->
					<div class="col-md-4">
						<el-form-item
							:label="tableDataModel.distribution_mainland_type.show_name"
							prop="distribution_mainland_type"
						>
							<field-editor
								v-model="info.distribution_mainland_type"
								@change.native="handleFormEdited('distribution_mainland_type')"
								@change="handleFormEdited('distribution_mainland_type')"
								:field-info="tableDataModel.distribution_mainland_type"
							></field-editor>
						</el-form-item>
						<el-form-item
							:label="tableDataModel.distribution_mainland.show_name"
							prop="distribution_mainland"
							v-if="info.distribution_mainland_type.index != 0"
						>
							<field-editor
								v-model="info.distribution_mainland"
								@change.native="handleFormEdited('distribution_mainland')"
								@change="handleFormEdited('distribution_mainland')"
								:field-info="tableDataModel.distribution_mainland"
							></field-editor>
						</el-form-item>
						<div class="tips">保持为空则使用品类默认值</div>
					</div>
					<div class="col-md-4">
						<el-form-item
							:label="tableDataModel.distribution_hongkong_type.show_name"
							prop="distribution_hongkong_type"
						>
							<field-editor
								v-model="info.distribution_hongkong_type"
								@change.native="handleFormEdited('distribution_hongkong_type')"
								@change="handleFormEdited('distribution_hongkong_type')"
								:field-info="tableDataModel.distribution_hongkong_type"
							></field-editor>
						</el-form-item>
						<el-form-item
							:label="tableDataModel.distribution_hongkong.show_name"
							prop="distribution_hongkong"
							v-if="info.distribution_hongkong_type.index != 0"
						>
							<field-editor
								v-model="info.distribution_hongkong"
								@change.native="handleFormEdited('distribution_hongkong')"
								@change="handleFormEdited('distribution_hongkong')"
								:field-info="tableDataModel.distribution_hongkong"
							></field-editor>
						</el-form-item>
						<div class="tips">保持为空则使用品类默认值</div>
					</div>
					<div class="col-md-4">
						<el-form-item
							:label="tableDataModel.distribution_oversea_type.show_name"
							prop="distribution_oversea_type"
						>
							<field-editor
								v-model="info.distribution_oversea_type"
								@change.native="handleFormEdited('distribution_oversea_type')"
								@change="handleFormEdited('distribution_oversea_type')"
								:field-info="tableDataModel.distribution_oversea_type"
							></field-editor>
						</el-form-item>
						<el-form-item
							:label="tableDataModel.distribution_oversea.show_name"
							prop="distribution_oversea"
							v-if="info.distribution_oversea_type.index != 0"
						>
							<field-editor
								v-model="info.distribution_oversea"
								@change.native="handleFormEdited('distribution_oversea')"
								@change="handleFormEdited('distribution_oversea')"
								:field-info="tableDataModel.distribution_oversea"
							></field-editor>
						</el-form-item>
						<div class="tips">保持为空则使用品类默认值</div>
					</div>
				</div>
			</el-form>
			<div class="text-center mt-3 mb-3">
				<el-button size="mini" type="primary" @click="doConfirmEditPrice()"
					>确 定</el-button
				>
			</div>
		</div>
		<!-- <div class="content-box mt-3">
			<div class="row">
				<div class="col-md-6">
					<h3 class="mb-3">颜色/型号</h3>
					<table class="table table-sm table-bordered table-striped">
						<tr v-for="(color,color_index) in value.colors" :key="color_index">
							<th>
								<span>{{color.name}}</span>
								<span class="pull-right text-muted">{{color.brand_show_id}}</span>
							</th>
							<td>
								<el-button
									type="default"
									size="mini"
									icon="el-icon-edit"
									@click="handleItemsReplace('colors',color_index)"
								>更换</el-button>

								<el-button
									type="default"
									size="mini"
									icon="el-icon-remove-outline"
									@click="doDel('colors',color_index)"
								>删除</el-button>
							</td>
						</tr>
						<tr>
							<th></th>
							<td>
								<el-button
									type="default"
									size="mini"
									icon="el-icon-circle-plus-outline"
									@click="handleItemsAddNew('colors')"
								>颜色</el-button>
							</td>
						</tr>
					</table>
				</div>
				<div class="col-md-6">
					<h3 class="mb-3">尺码/规格</h3>

					<table class="table table-sm table-bordered table-striped">
						<tr v-for="(model,model_index) in value.models" :key="model_index">
							<th>
								<span>{{model.name}}</span>
							</th>
							<td>
								<el-button
									type="default"
									size="mini"
									icon="el-icon-edit"
									@click="handleItemsReplace('models',model_index)"
								>更换</el-button>

								<el-button
									type="default"
									size="mini"
									icon="el-icon-remove-outline"
									@click="doDelModel(model._id,model_index)"
								>删除</el-button>
							</td>
						</tr>
						<tr>
							<th></th>
							<td></td>
						</tr>
					</table>
				</div>
			</div>
		</div>-->
		<div class="content-box mt-3" v-if="userPrivilegeMapping[12]">
			<div class="tips-box" v-if="info.model_preset._id">
				预置尺码 {{ info.model_preset.name }}
			</div>
			<el-button
				type="default"
				size="mini"
				icon="el-icon-circle-plus-outline"
				@click="handleItemsAddNew('models')"
				>尺码/规格</el-button
			>
			<el-tooltip
				:content="calcPresetDetail(preset.models)"
				placement="top"
				v-for="(preset, index) in totalModelPreset"
				:key="preset._id"
			>
				<el-button type="primary" size="mini" @click="handleItemsAddNewModelPreset(index)"
					>+ {{ preset.name }}</el-button
				>
			</el-tooltip>
			<curd-table
				:has-delete="false"
				ref="listTable"
				:data-model="editorDataModel"
				:fields="tableFields"
				:kv-filter="{
					product_color: { k: 'product_color', t: 'id', v: recordId, lge: '==' },
				}"
			>
				<template slot="listOp" slot-scope="scope">
					<el-button size="mini" type="text" @click="handleEditItem(scope.row._id)"
						>编辑</el-button
					>
					<el-button
						type="text"
						size="mini"
						icon="el-icon-remove-outline"
						@click="doDelModel(scope.row.model)"
						>删除</el-button
					>
				</template>
			</curd-table>
		</div>

		<el-dialog title="选择颜色/型号" :visible.sync="colors.dialog">
			<div v-if="colors.dialog">
				<color-input
					v-model="colors.color"
					:filter-brand="info.brand"
					:name-fields="['name', 'brand_show_id']"
				></color-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="colors.dialog = false">取 消</el-button>
				<el-button type="primary" @click="doChoose('colors')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择尺寸/规格" :visible.sync="models.dialog">
			<div v-if="models.dialog">
				<model-input v-model="models.model" :filter-classify="info.classify"></model-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="models.dialog = false">取 消</el-button>
				<el-button type="primary" @click="doChooseModel()">确 定</el-button>
			</span>
		</el-dialog>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable()"
		></editor>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";
import ColorInput from "@/widgets/Inputs/ColorInput.vue";
import ModelInput from "@/widgets/Inputs/ModelInput.vue";
import Editor from "@/components/Editor.vue";
import CurdTable from "@/components/CurdTable.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import {RenderPrice} from "@/mixinsApp/Render";

export default {
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
				price: false,
			},
			styles: [],
			everEdited: false,
			rules: {},
			colors: {
				dialog: false,
				color: {
					_id: "",
					name: "",
					brand_show_id: "",
				},
			},
			info: {
				distribution_mainland_type: {
					index: 2,
				},
				distribution_hongkong_type: {
					index: 0,
				},
				distribution_oversea_type: {
					index: 0,
				},
			},
			models: {
				dialog: false,
				model: {
					_id: "",
					name: "",
				},
			},
			fields: [
				{
					name: "price_0",
					rules: ["required"],
					col: 6,
					// width: "100%"
				},
        {
          name: "price_6",
          rules: ["required"],
          col: 6,
        },
				{
					name: "price_1",
					rules: ["required"],
					col: 6,
				},
				{
					name: "price_2",
					rules: ["required"],
					col: 6,
				},
				{
					name: "price_3",
					col: 6,
					// width: "100%"
				},
				{
					name: "price_4",
					col: 6,
					// width: "100%"
				},
				// {
				// 	name: "price_5",
				// 	col: 6,
				// 	// width: "100%"
				// },
				{
					name: "cost_per",
					col: 6,
					// width: "100%"
				},
				{
					name: "is_special",
					col: 4,
					// width: "100%"
				},
				{
					name: "price_in_active",
					col: 4,
					// width: "100%"
				},
			],
			editorVisible: false,
			editorId: "",
			tableFields: [
				{
					name: "model",
					sortable: "custom",
				},
				{
					name: "_id",
					sortable: "custom",
				},
				{
					name: "price_0",
					sortable: "custom",
				},
        {
          name: "price_6",
          sortable: "custom",
        },
				{
					name: "price_1",
					sortable: "custom",
				},
				{
					name: "price_2",
					sortable: "custom",
				},
				{
					name: "price_3",
					sortable: "custom",
				},
				{
					name: "price_4",
					sortable: "custom",
				},
				// {
				// 	name: "price_5",
				// 	sortable: "custom",
				// },
			],
			editorDataModel: "Item",
			editorFields: [
				{
					name: "model",
					isOnlyShow: true,
				},
				{
					name: "color",
					isOnlyShow: true,
				},
				{
					name: "cost_per",
				},
				{
					name: "price_0",
					sortable: "custom",
				},
        {
          name: "price_6",
          sortable: "custom",
        },
				{
					name: "price_1",
					sortable: "custom",
				},
				{
					name: "price_2",
					sortable: "custom",
				},
				{
					name: "price_3",
					sortable: "custom",
				},
				{
					name: "price_4",
					sortable: "custom",
				},
				// {
				// 	name: "price_5",
				// 	sortable: "custom",
				// },
			],
			totalModelPreset: [],
		};
	},
	props: {
		dataModel: {
			type: String,
			default: "",
		},
		hasGetTableDataModel: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
					_id: "",
					colors: [],
					models: [],
					items: [],
				};
			},
		},
		tableDataModel: {
			type: Object,
			default: () => {
				return {};
			},
		},
		recordId: {
			type: String,
			default: "",
		},
		show: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: "name",
		},
		handlerCtrller: {
			type: String,
			default: "curd",
		},
	},
	mounted() {
		this.getTotalModelPreset();
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},
	methods: {
		calcPresetDetail(presetModels) {
			return presetModels
				.map((val) => {
					return val.name;
				})
				.join(",");
		},
		handleItemsAddNewModelPreset(index) {
			this.$confirm(
				"确认使用" +
					this.totalModelPreset[index].name +
					"预置尺码：" +
					this.calcPresetDetail(this.totalModelPreset[index].models),
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				},
			)
				.then(() => {
					this.loadings.main = true;
					this.$axios
						.post(`/spu/add_preset_model/${this.recordId}`, {
							preset: this.totalModelPreset[index]._id,
						})
						.then((json) => {
							this.loadings.main = false;
							for (let k in json.data.info) {
								this.$set(this.info, k, json.data.info[k]);
							}
							this.$emit("change", this.info);

							this.$refs["listTable"].refreshData();
						})
						.catch((json) => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		handleItemsAddNew(type) {
			this[type].dialog = true;
			this.reset(type);
		},
		reset(type) {
			this[type].index = -1;
			if (type == "colors") {
				this.colors.color = Object.assign(
					{
						_id: "",
						name: "",
						brand_show_id: "",
					},
					{},
				);
			}
		},
		handleItemsReplace(type, index) {
			this.reset(type);

			this[type].dialog = true;
			this[type].index = index;
		},
		doChooseModel() {
			if (this.models.index == -1) {
				//创建
				this.loadings.main = true;
				this.$axios
					.post(`/spu/add_model/${this.recordId}`, {
						model: this.models.model._id,
					})
					.then((json) => {
						this.loadings.main = false;
						this.models.dialog = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$emit("change", this.info);

						this.$refs["listTable"].refreshData();
					})
					.catch((json) => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
			} else {
				this.loadings.main = true;
				let type = "model";
				let post = {
					old_id: this.value[type][this[type].index]._id,
				};
				if (type == "colors") {
					post["color"] = this.colors.color;
				} else {
					post["model"] = this.models.model;
				}

				this.$axios
					.post(`/inventory/replace_items/${type}/${this.recordId}`, post)
					.then((json) => {
						this.loadings.main = false;
						this[type].dialog = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$emit("change", this.info);

						this.$refs["listTable"].refreshData();
					})
					.catch((json) => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
			}
		},
		doChoose(type) {
			if (this[type].index == -1) {
				//创建
				this.loadings.main = true;
				this.$axios
					.post(`/inventory/add_items/${type}/${this.recordId}`, {
						color: this.colors.color,
						model: this.models.model,
					})
					.then((json) => {
						this.loadings.main = false;
						this[type].dialog = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$emit("change", this.info);

						this.$refs["listTable"].refreshData();
					})
					.catch((json) => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
			} else {
				this.loadings.main = true;
				let post = {
					old_id: this.value[type][this[type].index]._id,
				};
				if (type == "colors") {
					post["color"] = this.colors.color;
				} else {
					post["model"] = this.models.model;
				}

				this.$axios
					.post(`/inventory/replace_items/${type}/${this.recordId}`, post)
					.then((json) => {
						this.loadings.main = false;
						this[type].dialog = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$emit("change", this.info);

						this.$refs["listTable"].refreshData();
					})
					.catch((json) => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
			}
		},
		doDelModel(model) {
			//创建
			this.$confirm("此操作将永久删除该条目" + model.name + ", 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.loadings.main = true;
					let post = {
						model: model._id,
					};
					this.$axios
						.post(`/spu/rm_model/${this.recordId}`, post)
						.then((json) => {
							this.loadings.main = false;
							// this.info.models.splice(index, 1);
							this.$refs["listTable"].refreshData();
							this.$emit("change", this.info);
						})
						.catch((json) => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},

		handleFormEdited(name) {
			this.everEdited = true;
			if (name.indexOf("price_") == 0) {
				let index = parseInt(name.substr(6, name.length - 6));
				if (index > 0 && index < 5) {
					for (let k = index + 1; k <= 5; k++) {
						if (this.value["price_" + k] == 0) {
							this.info["price_" + k] = this.info["price_" + index];
						}
					}
				}
			}
		},
		handleSelect() {},

		handleEditItem(id) {
			console.log("edit", id);
			this.editorId = id;
			this.editorVisible = true;
		},
		doConfirmEditPrice() {
			this.$refs["priceForm"].validate((valid) => {
				if (!valid) {
					return false;
				}
				this.loadings.price = true;
				this.$axios
					.post(`/spu/do_edit_price/${this.recordId}`, this.info)
					.then((json) => {
						this.loadings.price = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$refs["listTable"].refreshData();
						this.$message.success("成功");
						this.$emit("change", this.info);
					})
					.catch((json) => {
						this.loadings.price = false;
						this.$message.error(json.data.msg);
					});
			});
		},
		_refreshRules() {
			for (let i = 0; i < this.fields.length; i++) {
				if (!this.fields[i].rules) {
					continue;
				}
				let real_rule = [];
				if (this.rules[this.fields[i].name]) {
					real_rule = this.rules[this.fields[i].name];
				}
				for (let j = 0; j < this.fields[i].rules.length; j++) {
					let rule = this.fields[i].rules[j];
					if (rule == "required") {
						if (
							this.tableDataModel[this.fields[i].name].type ==
							"Field_relate_simple_id"
						) {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
								type: "object",
								fields: {
									_id: { type: "string", required: true, message: "请选择" },
								},
							});
						} else {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
							});
						}
					} else if (rule !== null && typeof rule === "object") {
						real_rule.push(rule);
					}
				}
				if (real_rule.length > 0) {
					this.$set(this.rules, this.fields[i].name, real_rule);
				}
			}
		},
		getTotalModelPreset() {
			this.$axios
				.post("/inventory/get_model_preset/", { classify: this.info.classify })
				.then((json) => {
					this.totalModelPreset = json.data.datas;
				})
				.catch((json) => {
					console.error(json);
					this.$message.error(json.data.msg);
				});
		},
	},
	components: {
		FieldEditor,
		ModelInput,
		ColorInput,
		Editor,
		CurdTable,
	},
	watch: {
		hasGetTableDataModel() {
			this._refreshRules();
		},
		value: {
			handler(val) {
				this.info = Object.assign({}, val);
			},
			immediate: true,
		},
	},
};
</script>